import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  StatusBar,
} from 'react-native';
import Icon from '../components/Icon';
import { useTheme } from '../context/ThemeContext';
import { vs, spacing, fontSize, iconSize } from '../utils/responsive';

const TermsScreen = ({ navigation }) => {
  const { colors, isDarkMode } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: colors.background }]}>
      <StatusBar barStyle={isDarkMode ? "light-content" : "dark-content"} backgroundColor={colors.background} />

      {/* Header */}
      <View style={[styles.header, { backgroundColor: colors.headerBackground, borderBottomColor: colors.border }]}>
        <TouchableOpacity onPress={() => navigation.goBack()} style={styles.backButton}>
          <Icon name="arrow-back" size={iconSize.md} color={colors.primary} />
        </TouchableOpacity>
        <Text style={[styles.headerTitle, { color: colors.primary }]}>Terms & Conditions</Text>
        <View style={styles.placeholder} />
      </View>

      <ScrollView style={styles.content} showsVerticalScrollIndicator={false}>
        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>1. Acceptance of Terms</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            By accessing and using this trading application, you accept and agree to be bound by the terms and provision of this agreement.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>2. Use License</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            Permission is granted to temporarily download one copy of the materials (information or software) on our application for personal, non-commercial transitory viewing only.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>3. Trading Risks</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            Trading involves substantial risk and is not suitable for every investor. You should carefully consider your financial situation and risk tolerance before trading. Past performance is not indicative of future results.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>4. Account Security</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>5. Prohibited Activities</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            You may not use this application for any illegal or unauthorized purpose. You must not violate any laws in your jurisdiction including but not limited to copyright laws.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>6. Limitation of Liability</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            In no event shall we or our suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on our application.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>7. Modifications</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            We may revise these terms of service for our application at any time without notice. By using this application you are agreeing to be bound by the then current version of these terms of service.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>8. Contact Information</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            If you have any questions about these Terms & Conditions, please contact our support team through the Help & Support section.
          </Text>
        </View>

        <View style={{ height: vs(40) }} />
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: spacing.base,
    paddingTop: vs(8),
    paddingBottom: vs(16),
    borderBottomWidth: 1,
  },
  backButton: {
    padding: spacing.xs,
  },
  headerTitle: {
    fontSize: fontSize.xl,
    fontWeight: '700',
  },
  placeholder: {
    width: 32,
  },
  content: {
    flex: 1,
    paddingHorizontal: spacing.base,
  },
  section: {
    marginTop: vs(24),
  },
  sectionTitle: {
    fontSize: fontSize.lg,
    fontWeight: '600',
    marginBottom: vs(8),
  },
  sectionText: {
    fontSize: fontSize.base,
    lineHeight: 24,
  },
});

export default TermsScreen;
